import PortableTextPlus from "@/components/portable-text-plus";
import classNames from "classnames";
import SegmentContainer from "@/components/segments/segment-container";
import CallToActionButton from "@/components/call-to-action-button";

export default function TwoColumnsSingleBlock({ segment, ...props }) {
  return (
    <SegmentContainer className={props.paddingClasses}>
      <div
        className={classNames(
          props.widthClasses,
          "flex flex-wrap justify-between sm:gap-x-8 text-center sm:text-left"
        )}
      >
        <div className="sm:flex-1">
          {segment.block.heading && (
            <div className="leading-snug text-xl font-bold prose">
              <PortableTextPlus value={segment.block.heading} />
            </div>
          )}
          {segment.block.callToActions && (
            <div className="mt-6 sm:mt-12 hidden sm:block space-y-4">
              {segment.block.callToActions.map((callToAction) => (
                <CallToActionButton
                  className="mr-4 w-64"
                  key={callToAction._key}
                  href={callToAction.url}
                  {...callToAction}
                >
                  {callToAction.title}
                </CallToActionButton>
              ))}
            </div>
          )}
        </div>
        {segment.block.content && (
          <div className="sm:flex-1 sm:text-lg prose">
            <PortableTextPlus value={segment.block.content} />
          </div>
        )}
      </div>
      {segment.block.callToActions && (
        <div className="block sm:hidden mt-8 text-center space-y-4">
          {segment.block.callToActions.map((callToAction) => (
            <CallToActionButton
              className="mr-4 w-64"
              key={callToAction._key}
              href={callToAction.url}
              {...callToAction}
            >
              {callToAction.title}
            </CallToActionButton>
          ))}
        </div>
      )}
    </SegmentContainer>
  );
}
